// extracted by mini-css-extract-plugin
export default {"informer":"informer--HeDz","info":"info--0fzM","title":"title--hiq4","text":"text--RSaK"};